import { useTranslation } from 'react-i18next';
import { PlusIcon } from '@c2fo/liquidity/icons';
import useEnableLendingConnections from '@/enterprise/features/lendingConnections/useEnableLendingConnections';
import { ButtonLink } from '@/shared/components/ButtonLink';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';

const AddCustomerBanner = () => {
  const enableLendingConnectionsIntegration = useEnableLendingConnections();
  const { t } = useTranslation();

  if (!enableLendingConnectionsIntegration) {
    return null;
  }

  return (
    <div className="mt-4 flex items-center justify-between rounded-lg border-2 border-dashed border-blue-300 bg-blue-50 p-6">
      <div>
        <p className="text-lg font-semibold text-text-primary">{t('takerMarketTabs.noMarkets.addCustomersButton')}</p>
        <p className="text-text-secondary">{t('homepage.addCustomersDescription')}</p>
      </div>
      <ButtonLink
        to={asEnterpriseLink('find-your-customers/expand-your-network')}
        variant="ancillary"
        icon={<PlusIcon className="fill-secondary-500" />}
      >
        {t('core.addCustomers')}
      </ButtonLink>
    </div>
  );
};

export default AddCustomerBanner;
